//import Swal from "sweetalert2";
//import Vue from "vue";
import store from '../../state/store';

import {
    addOffer, approveOffer,
    deleteOffer,
    getList,
    getSingle,
    updateOffer
} from "@/services/modules/offer/offerService";
import { showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage } from "../alertHelpers.js";

export const state = {
    offerList: [],
    offerListHeaders: [],
    offerListLoading: false,
    offerListMetaData: []

};

export const mutations = {
    setOfferList(state, data) {
        state.offerList = data;
    },
    setOfferListHeaders(state, data) {
        state.offerListHeaders = data;
    },
    setOfferListLoading(state, data) {
        state.offerListLoading = data;
    },
    setOfferListMetaData(state, data) {
        state.offerListMetaData = data;
    }
}

export const getters = {

};

export const actions = {

    async fetchOfferList(context, { params, body }) {
        context.commit("setOfferListLoading", true)
        context.commit('setOfferListHeaders', [
            {
                key: 'date',
                label: 'Teklif Tarihi',
                sortable: false,

            },
            {
                key: 'validityDate',
                label: 'Geçerlilik Tarihi',
                sortable: false,

            },
            {
                key: 'offerNumber',
                label: 'Teklif Numarası',
                sortable: false,

            },
            {
                key: 'currentCode',
                label: 'Cari Kodu',
                sortable: false,

            },
            {
                key: 'currentName',
                label: 'Cari Adı',
                sortable: false,

            },
            {
                key: 'currentEmail',
                label: 'Cari E-Posta',
                sortable: false,

            },
            {
                key: 'status',
                label: 'Durum',
                sortable: false,

            },
            {
                key: 'process',
                label: 'İşlem',
                sortable: false,
                class: "text-center"

            }
        ]);
        let result = await getList(params, body);
        context.commit("setOfferList", result.data.data);

        context.commit("setOfferListLoading", false)
        return result;
    },

    async fetchSingleOffer(context, { params, body, urlSegments }) {
        context;
        let result = await getSingle(params, body, urlSegments);
        return result;
    },

    async offerAdd(context, { params, body }) {
        context;
        let result = await addOffer(params, body)

        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }

        else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },

    async offerUpdate(context, { params, body }) {
        context;
        let result = await updateOffer(params, body)

        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
            context.dispatch("fetchAnnouncementList", {
                params: {
                    userId: store.state.auth.user.UserId
                },
                body: {}
            })
        }
        else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },

    async offerDelete(context, { params, body }) {
        context;
        showProcessPromptMessage({
            title: 'Duyuru Silinecek',
            text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
                if (confirm.isConfirmed) {

                    let result = await deleteOffer(params, body);
                    if (result.data.success) {
                        showProcessSuccessMessage({
                            title: 'İşlem Başarılı',
                            text: result.data.message
                        })
                        context.dispatch("fetchAnnouncementList", {
                            params: {
                                userId: store.state.auth.user.UserId
                            },
                            body: {}
                        })
                    }
                    else
                        showProcessErrorMessage({
                            title: 'İşlem Başarısız',
                            text: result.data.message
                        })

                    return result;
                }
            }
        )
    },

    async offerApprove(context, { params, body }) {
        context;
        let result = await approveOffer(params, body)

        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        }

        else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },



};
